export const STOP_TYPE = {
  DROPOFF: 'DROP_OFF',
  RETURN: 'RETURN',
};

export const SHIPMENT_STOP_TYPE = {
  DROPOFF: 'deliverShipment',
  PICKUP: 'pickupShipment',
};

export const CREW_TYPES = [
  {
    label: 'POOL 1',
    value: 'POOL_1',
    hide: false,
  },
  {
    label: 'POOL 2',
    value: 'POOL_2',
    hide: false,
  },
  {
    label: 'LARGE VEHICLE',
    value: 'LARGE_VEHICLE',
    hide: false,
  },
  {
    label: 'HIGHEST PRIORITY',
    value: 'HIGHEST_PRIORITY',
    hide: false,
  },
  {
    label: 'CUSTOM',
    value: 'CUSTOM',
    hide: false,
  },
  {
    label: 'POOL 3',
    value: 'POOL_3',
    hide: true,
  },
  {
    label: 'POOL 4',
    value: 'POOL_4',
    hide: true,
  },
  {
    label: 'CLEANER EMISSIONS',
    value: 'CLEANER_EMISSIONS',
    hide: true,
  },
  {
    label: 'LARGE VEHICLE SINGLE',
    value: 'LARGE_VEHICLE_SINGLE',
    hide: true,
  },
  {
    label: 'POOL1_SINGLE',
    value: 'POOL1_SINGLE',
    hide: true,
  },
  {
    label: 'POOL2_SINGLE',
    value: 'POOL2_SINGLE',
    hide: true,
  },
  {
    label: 'SPECIALTY',
    value: 'SPECIALTY',
    hide: true,
  },
];

export const NOTIFY_TYPE = {
  SMS: 'sms',
  EMAIL: 'email',
  PUSH: 'push_notification',
};
